export default [{
  id: 'afc91c79-0af8-4632-b2c6-c696e2e9a6e9', // id 全局唯一，终身制
  name: 'constructionScheduleManagement',
  path: '/construction-schedule-management',
  meta: {
    title: '施工计划任务管理'
  },
  // layout: 'default',
  // 根菜单不需要定义 component，由主框架定义
  children: [{
    id: '269581e4-6d5f-430c-b68e-265d3ed45ab8',
    path: 'index',
    name: 'scheduleList',
    component(resolve) {
      require(['./views/index'], resolve)
    },
    meta: {
      title: '任务编制',
      operations: {
        create: {
          id: 0,
          name: 'create',
          desc: '新增',
          access: true,
        },
        read: {
          id: 1,
          name: 'read',
          desc: '详情',
          access: true,
          group: 'read',
        },
        update: {
          id: 2,
          name: 'update',
          desc: '修改',
          access: true,
        },
        delete: {
          id: 3,
          name: 'delete',
          desc: '删除',
          access: true,
        }
      },
    },
  },
  {
    id: 'c3e050da-8cc4-4a12-b87f-48e8920efc2a',
    path: 'associated-object',
    name: 'associatedObject',
    component(resolve) {
      require(['./views/associated'], resolve)
    },
    meta: {
      title: '关联对象',
      hidden: true,
      operations: {
        create: {
          id: 0,
          name: 'create',
          desc: '新增',
          access: true,
        },
        read: {
          id: 1,
          name: 'read',
          desc: '详情',
          access: true,
          group: 'read',
        },
        update: {
          id: 2,
          name: 'update',
          desc: '修改',
          access: true,
        },
        delete: {
          id: 3,
          name: 'delete',
          desc: '删除',
          access: true,
        },
      },
    },
  },

  ],
}, ]
